import React, { useState, useEffect } from "react";

const ProductForm = ({ onSave, selectedProduct, categorias }) => {
  const [formData, setFormData] = useState({
    nombre: "",
    descripcion: "",
    stock: 0,
    unidadMedida: "",
    costoUnitario: 0,
    esPrestamo: false,

    categoriaId: "",
    nuevaCategoria: "",
  });
  const [error, setError] = useState("");

  
  // Actualizar el formulario si se selecciona un producto
  useEffect(() => {
    if (selectedProduct) {
      setFormData({
        nombre: selectedProduct.nombre || "",
        descripcion: selectedProduct.descripcion || "",
        stock: selectedProduct.stock || 0,
        unidadMedida: selectedProduct.unidadMedida || "",
        costoUnitario: selectedProduct.costoUnitario || 0,
        esPrestamo: selectedProduct.esPrestamo || false,

        categoriaId: selectedProduct.categoria?.id || "",
        nuevaCategoria: "",
      });
    } else {
      resetForm();
    }
  }, [selectedProduct]);

  // Manejar cambios en el formulario
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  // Resetear el formulario
  const resetForm = () => {
    setFormData({
      nombre: "",
      descripcion: "",
      stock: 0,
      unidadMedida: "",
      esPrestamo: false,
      categoriaId: "",
      nuevaCategoria: "",
    });
  };

  // Manejar envío del formulario
  const handleSubmit = (e) => {
    e.preventDefault();
    // La categoría puede venir del listado o escribirse como nueva
    if (!formData.categoriaId && !formData.nuevaCategoria.trim()) {
      setError("Elegí una categoría del listado o escribí una nueva.");
      return;
    }
    setError("");
    onSave(formData);
    resetForm();
  };

  return (
    <form
      onSubmit={handleSubmit}
      className="bg-backgroundOscuro p-6 rounded-lg shadow-md text-textoClaro"
    >
      <h2 className="text-xl font-bold mb-4">
        {selectedProduct ? "Editar Producto" : "Crear Producto"}
      </h2>

      <div className="mb-4">
        <label htmlFor="nombre" className="block text-sm font-medium mb-2">
          Nombre del Producto
        </label>
        <input
          type="text"
          id="nombre"
          name="nombre"
          value={formData.nombre}
          onChange={handleChange}
          className="w-full p-2 rounded bg-backgroundClaro text-textoOscuro"
          required
        />
      </div>

      <div className="mb-4">
        <label htmlFor="descripcion" className="block text-sm font-medium mb-2">
          Descripción
        </label>
        <textarea
          id="descripcion"
          name="descripcion"
          value={formData.descripcion}
          onChange={handleChange}
          className="w-full p-2 rounded bg-backgroundClaro text-textoOscuro"
        />
      </div>

      <div className="mb-4">
        <label htmlFor="stock" className="block text-sm font-medium mb-2">
          Stock
        </label>
        <input
          type="number"
          id="stock"
          name="stock"
          value={formData.stock}
          onChange={handleChange}
          className="w-full p-2 rounded bg-backgroundClaro text-textoOscuro"
          required
        />
      </div>

      <div className="mb-4">
        <label
          htmlFor="unidadMedida"
          className="block text-sm font-medium mb-2"
        >
          Unidad de Medida
        </label>
        <select
          id="unidadMedida"
          name="unidadMedida"
          value={formData.unidadMedida}
          onChange={handleChange}
          className="w-full p-2 rounded bg-backgroundClaro text-textoOscuro"
          required
        >
          <option value="">Seleccionar unidad de medida</option>
          {[
            { value: "kg", label: "Kilogramo (kg)" },
            { value: "g", label: "Gramo (g)" },
            { value: "t", label: "Tonelada (t)" },
            { value: "l", label: "Litro (l)" },
            { value: "ml", label: "Mililitro (ml)" },
            { value: "m", label: "Metro (m)" },
            { value: "cm", label: "Centímetro (cm)" },
            { value: "mm", label: "Milímetro (mm)" },
            { value: "pz", label: "Pieza (pz)" },
            { value: "caja", label: "Caja" },
            { value: "paq", label: "Paquete (paq)" },
            { value: "rollo", label: "Rollo" },
            { value: "bot", label: "Botella" },
            { value: "bid", label: "Bidón" },
            { value: "barr", label: "Barril" },
            { value: "saco", label: "Saco" },
            { value: "bulto", label: "Bulto" },
            { value: "fardo", label: "Fardo" },
            { value: "tarro", label: "Tarro" },
            { value: "sobre", label: "Sobre" },
            { value: "granel", label: "Granel" },
            { value: "unidad", label: "Unidad" },
            { value: "doc", label: "Docena" },
            { value: "par", label: "Par" },
            { value: "hoja", label: "Hoja" },
            { value: "m2", label: "Metro cuadrado (m²)" },
            { value: "m3", label: "Metro cúbico (m³)" },
            { value: "kwh", label: "Kilovatio hora (kWh)" },
            { value: "cc", label: "Centímetro cúbico (cc)" },
            { value: "gal", label: "Galón" },
            { value: "lb", label: "Libra (lb)" },
            { value: "oz", label: "Onza (oz)" },
          ].map((unidad) => (
            <option key={unidad.value} value={unidad.value}>
              {unidad.label}
            </option>
          ))}
        </select>
      </div>
      <div className="mb-4">
        <label htmlFor="categoriaId" className="block text-sm font-medium mb-2">
          Categoría
        </label>
        <select
          id="categoriaId"
          name="categoriaId"
          value={formData.categoriaId}
          onChange={handleChange}
          className="w-full p-2 rounded bg-backgroundClaro text-textoOscuro"
        >
          <option value="">Seleccionar categoría</option>
          {categorias?.map((cat) => (
            <option key={cat.id} value={cat.id}>
              {cat.nombre}
            </option>
          ))}
        </select>
      </div>

      <div className="mb-4">
        <label
          htmlFor="nuevaCategoria"
          className="block text-sm font-medium mb-2"
        >
          Nueva Categoría (opcional)
        </label>
        <input
          type="text"
          id="nuevaCategoria"
          name="nuevaCategoria"
          value={formData.nuevaCategoria}
          onChange={handleChange}
          className="w-full p-2 rounded bg-backgroundClaro text-textoOscuro"
        />
      </div>

      <div className="mb-4">
        <label htmlFor="esPrestamo" className="inline-flex items-center">
          <input
            type="checkbox"
            id="esPrestamo"
            name="esPrestamo"
            checked={formData.esPrestamo}
            onChange={handleChange}
            className="mr-2"
          />
          Es Préstamo
        </label>
      </div>

      {error && (
        <p className="mb-2 p-2 rounded-md bg-red-900 text-textoClaro text-sm">
          {error}
        </p>
      )}

      <button
        type="submit"
        className="bg-green-900 w-full flex items-center my-2 p-2 rounded-md text-textoClaro font-bold text-lg hover:bg-green-600 shadow-lg shadow-green-500/50"
      >
        {selectedProduct ? "Actualizar Producto" : "Crear Producto"}
      </button>
    </form>
  );
};

export default ProductForm;